export const paymentFlowStatus = {
    STARTED: 'STARTED',
    PROCESSING: 'PROCESSING',
    FINISHED_SUCCESS: 'FINISHED_SUCCESS',
    FINISHED_FAILURE: 'FINISHED_FAILURE'
}

export const getWebAppUrl = (isLive) => {
  return isLive
    ? 'https://vrs.racing'
    : 'http://localhost:3000'
}
